import { render, staticRenderFns } from "./GetTicket.vue?vue&type=template&id=46dada54&scoped=true&"
import script from "./GetTicket.vue?vue&type=script&lang=js&"
export * from "./GetTicket.vue?vue&type=script&lang=js&"
import style0 from "./GetTicket.vue?vue&type=style&index=0&id=46dada54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46dada54",
  null
  
)

export default component.exports